import { emptySplitApi, RootState } from 'shared/store/store'
import { GlobalSearchResultModel } from '../model'
import { getActiveClient } from 'shared/store/clients/selectors'

type GlobalSearchArgs = {
  searchQuery: string
  params: string[]
}

const baseUrl = 'globalsearchportal/GlobalSearch/'

const emptyState: GlobalSearchResultModel = {
  boardMeetingCases: {
    total: 0,
    hits: [],
  },
  menuItems: {
    total: 0,
    hits: [],
  },
  invoices: {
    total: 0,
    hits: [],
  },
  accounts: {
    total: 0,
    hits: [],
  },
  boardDocuments: {
    total: 0,
    hits: [],
  },
  bblDocuments: {
    total: 0,
    hits: [],
  },
  prosjektarkivDocuments: {
    total: 0,
    hits: [],
  },
}

const globalSearchService = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    search: build.query<GlobalSearchResultModel, GlobalSearchArgs>({
      queryFn: async (
        { searchQuery, params }: GlobalSearchArgs,
        { getState },
        _extraOpts,
        query
      ) => {
        const state = getState() as RootState
        const currentClient = getActiveClient(state)

        if (!currentClient) {
          throw new Error('No active client')
        }

        const joinedParams = params.join('&')

        if (searchQuery === '') {
          return { data: emptyState }
        }

        const url = `${baseUrl}${currentClient.id}/search?query=${
          searchQuery || ' '
        }${joinedParams}`

        const res = await query({
          url,
          method: 'GET',
        })

        if (res.error) {
          return { error: res.error }
        }

        return {
          data: res.data as GlobalSearchResultModel,
        }
      },
    }),
  }),
})

export const { useSearchQuery } = globalSearchService

export default globalSearchService
